var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox-wrapper"},[_c('div',{class:['custom-checkbox', { checked: _vm.localValue }, { disabled: _vm.disabled }],attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.doToggle()}}},[(_vm.localValue)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]),_c('label',{staticClass:"inline"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }